// extracted by mini-css-extract-plugin
module.exports = {"smallNumberInput":"EditCourse_smallNumberInput__NXMMX"};